import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { Cotizacion } from '../../Cotizacion/models/cotizacion';
import { CotizacionesService } from '../../Service/cotizaciones-service'; 
import { ToastService } from '../../Service/toast-service';

@Component({
  selector: 'app-cotizaciones-list',
  imports: [CommonModule, RouterOutlet, RouterLink, FormsModule],
  templateUrl: './cotizaciones-list.html',
  styleUrl: './cotizaciones-list.css',
})
export class CotizacionesList implements OnInit {
  public cotizaciones: Cotizacion[] = [];
  public cotizacionesFiltradas: Cotizacion[] = [];
  public filtroTexto: string = '';

  // 🧭 Paginación reactiva adaptada al estándar JDE del taller
  public paginaActual: number = 1;
  public registrosPorPagina: number = 10; 
  public totalPaginas: number = 1;

  protected readonly Math = Math;

  constructor(
    private cotizacionesService : CotizacionesService,
    public toastService: ToastService,
    private _router: Router,
    private _cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cargarCotizaciones();
  }

  public cargarCotizaciones(): void {
    console.log('>>> [ERP JDE] Solicitando matriz de cotizaciones y presupuestos en red...');
    this.cotizacionesService.getAll().subscribe({
      next: (data: Cotizacion[]) => {
        console.log('>>> [SaaS Cotizaciones] Datos financieros crudos recibidos:', data);
        
        this.cotizaciones = data;
        this.cotizacionesFiltradas = [...this.cotizaciones];
        
        this.calcularTotalPaginas();
        this._cdr.markForCheck();
        this._cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error crítico al descargar el histórico de cotizaciones:', err);
        this.toastService.showDanger(
          'Fallo de Sincronización', 
          'No se pudo conectar con el endpoint comercial. Verifique el puerto del microservicio.'
        );
        this._cdr.detectChanges();
      }
    });
  }

  public filtrarCotizaciones(): void {
    const busqueda = this.filtroTexto.trim().toUpperCase();
    if (!busqueda) {
      this.cotizacionesFiltradas = [...this.cotizaciones];
      this.calcularTotalPaginas();
      this._cdr.detectChanges();
      return;
    }

    this.cotizacionesFiltradas = this.cotizaciones.filter(c => {
      return (c.folioCotizacion && c.folioCotizacion.toUpperCase().includes(busqueda)) ||
             (c.placasVehiculo && c.placasVehiculo.toUpperCase().includes(busqueda)) ||
             (c.submarcaVehiculo && c.submarcaVehiculo.toUpperCase().includes(busqueda)) ||
             (c.nombreCliente && c.nombreCliente.toUpperCase().includes(busqueda)) ||
             (c.an8Cliente && c.an8Cliente.toString().includes(busqueda)) ||
             (c.estatusAprobacion && c.estatusAprobacion.toUpperCase().includes(busqueda));
    });

    this.paginaActual = 1;
    this.calcularTotalPaginas();
    this._cdr.detectChanges();
  }

  public abrirEditor(cotizacionId: number): void {
    console.log('🚀 [SaaS Cotizaciones] Redireccionando a Pantalla Completa de Edición para Cotización ID:', cotizacionId);
    this._router.navigate(['/cotizaciones/edit', cotizacionId]);
  }

  public eliminarCotizacion(id: number): void {
    if (confirm('¿Está seguro de eliminar este presupuesto de forma permanente? Esta acción no se puede deshacer.')) {
      this.cotizacionesService.delete(id).subscribe({
        next: () => {
          this.toastService.showSuccess('Operación Exitosa', 'El presupuesto ha sido borrado del sistema.');
          this.cargarCotizaciones();
        },
        error: (err) => {
          console.error('Error al remover el registro:', err);
          this.toastService.showDanger('Error', 'No se pudo eliminar el registro seleccionado.');
        }
      });
    }
  }

  public calcularTotalPaginas(): void {
    this.totalPaginas = Math.ceil(this.cotizacionesFiltradas.length / this.registrosPorPagina) || 1;
    this._cdr.detectChanges();
  }

  public cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      console.log('>>> [PREFS JDE] Conmutando rejilla comercial a la página:', this.paginaActual);
      this._cdr.detectChanges();
    }
  }

  get cotizacionesPaginadas(): Cotizacion[] {
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    return this.cotizacionesFiltradas.slice(inicio, fin);
  }
}
